import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import ArrowSimpleUpSvg from './arrowSimpleUp.svg';

export const ArrowSimpleUpIcon = (props: any) => <Icon component={ArrowSimpleUpSvg} {...props} />;

export const ArrowSimpleUpButton = ({ size = 'medium', iconSize = 24, ...props }: IconButtonProps) => (
  <Button
    type={ButtonType.OutlineIcon}
    icon={<ArrowSimpleUpIcon width={iconSize} height={iconSize} />}
    size={size}
    {...props}
  />
);
